<template>
    <div class="compare-countries-button"        
    >
        <v-btn 
        class="compare-countries-btn midnightButton buttonBranding_midnight" 
        rounded
        @click="changeCompareMode"
        flat
        :ripple="false"
        >
            <span class="buttonText">Compare countries</span>
        </v-btn>
    </div>
    
</template>

<script lang="ts"> 
import {
    defineComponent
} from 'vue';

export default defineComponent({
    name: 'CompareCountriesButton',
    data() {
        return {
            isMobile: window.innerWidth <= 900,
  
        };
    },
    mounted() {
        // 
    },
    methods: {
        changeCompareMode() {

            this.$emit('changeCompareMode');
        }
    },

});
</script>

<style scoped>

.compare-countries-button {
    display: flex;
}

.compare-countries-btn {
    background-color: #333333; /* Adjust this color as needed */
    color: white;
    padding: 25px 24px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    
    /* Font */

    font-family: 'GCO Sans' !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.8px;
    text-align: left;
    letter-spacing: 0.48px;

    text-transform: none;

    cursor: pointer;
}

.icon {
    font-size: 24px;
    margin-left: 10px;
    margin-right: -10px;
}

.compare-countries-button .buttonText,
.compare-countries .icon 
{
    margin-top: 3px !important;
}
</style>
